import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { LocationService } from 'src/app/shared/services/API/pharmacy/location.service';
import { StorageAmountLocationService } from 'src/app/shared/services/API/pharmacy/storage-amount-location.service';
import { LocationModel } from 'src/app/shared/services/models/pharmacy/location.model';
import { StorageMoveRequest } from 'src/app/shared/services/requests/pharmacy/storage-move.request';
import { StorageAmountLocationStruct } from 'src/app/shared/services/structs/pharmacy/storage-amount-location.struct';

@Component({
    selector: 'app-pharmacy-move-location-modal',
    templateUrl: './pharmacy-move-location-modal.component.html',
    styleUrls: ['./pharmacy-move-location-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PharmacyMoveLocationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PharmacyMoveLocationModalComponent>,
    private locationService: LocationService,
    private storageAmountLocationService: StorageAmountLocationService,
    private formBuilder: FormBuilder,
    private alertService: AlertService
  ) { }

  public isLoading: boolean = true;

  public model: FormGroup;
  public storageAmountLocation: StorageAmountLocationStruct;

  public listLocation: LocationModel[] = [];

  ngOnInit(): void {
    this.storageAmountLocation = this.data.storageAmountLocation;

    this.model = this.formBuilder.group({
      amount: [null, [Validators.required, Validators.min(1), Validators.max(this.storageAmountLocation.amountRemaining)]],
      idLocation: [null, [Validators.required]],
    });

    this.getValidLocations();
  }

  close() {
    this.matDialogRef.close({ moveLocation: false });
  }

  submit() {
    if (this.isLoading)
      return;
    if (!this.model.valid) {
      this.alertService.show('Erro', "Preencha todos em vermelho", AlertType.error);
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    let request: StorageMoveRequest = new StorageMoveRequest();
    request.idStorageAmountLocation = this.storageAmountLocation.idStorageAmountLocation;
    request.newIdLocation = this.model.get('idLocation').value;
    request.amount = this.model.get('amount').value;

    this.storageAmountLocationService.returnProduct(request).subscribe((response) => {

      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      this.alertService.show('Sucesso', "Informações salvas com sucesso", AlertType.success);
      this.isLoading = false;

      this.matDialogRef.close({ moveLocation: true });
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  getValidLocations() {
    console.log("this.storageAmountLocation: ", this.storageAmountLocation)
    this.locationService.getLocationsToMove(this.storageAmountLocation.idLocation).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listLocation = response.listLocation;
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  clickCancel() {
    this.close();
  }
}